import { render, staticRenderFns } from "./YA_footer.vue?vue&type=template&id=12a30fae&scoped=true"
import script from "./YA_footer.vue?vue&type=script&lang=js"
export * from "./YA_footer.vue?vue&type=script&lang=js"
import style0 from "./YA_footer.vue?vue&type=style&index=0&id=12a30fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a30fae",
  null
  
)

export default component.exports